var styles = [".debug-container[_ngcontent-%COMP%]{z-index:1059;max-width:40%;bottom:0;background-color:rgba(100,100,100,.3);border:1px solid rgba(0,0,0,.5)}.close[_ngcontent-%COMP%]{position:absolute;top:0;right:3px}"];
export { styles as styles };
